import { ScoreBar } from '../../styles'
import { Container, Content, IconContainer } from './styles'

type Props = {
  title: string
  icon: React.ReactNode
}

export const LoadingStatus = (props: Props) => {
  const { icon, title } = props

  return (
    <Container>
      <Content>
        <IconContainer>{icon}</IconContainer>
        {title}
      </Content>
      <ScoreBar $score={0} />
    </Container>
  )
}
